// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3jNQV","title":"BackImages_title__uXUc_","images":"BackImages_images__wZhyx"};